var map = {
	"./addminus": 825,
	"./addminus.svg": 825,
	"./addplus": 833,
	"./addplus.svg": 833,
	"./alertTriangle": 834,
	"./alertTriangle.svg": 834,
	"./archiveFolder": 835,
	"./archiveFolder.svg": 835,
	"./arrow": 837,
	"./arrow-right": 836,
	"./arrow-right.svg": 836,
	"./arrow.svg": 837,
	"./arrowBow": 838,
	"./arrowBow.svg": 838,
	"./arrowDownCarret": 839,
	"./arrowDownCarret.svg": 839,
	"./arrowUpCarret": 840,
	"./arrowUpCarret.svg": 840,
	"./arrowdown2": 841,
	"./arrowdown2.svg": 841,
	"./arrowleft": 842,
	"./arrowleft.svg": 842,
	"./arrowleft2": 843,
	"./arrowleft2.svg": 843,
	"./arrowright": 844,
	"./arrowright.svg": 844,
	"./arrowright2": 845,
	"./arrowright2.svg": 845,
	"./arrowup2": 846,
	"./arrowup2.svg": 846,
	"./baby": 847,
	"./baby.svg": 847,
	"./basket": 848,
	"./basket.svg": 848,
	"./bell": 849,
	"./bell.svg": 849,
	"./bin": 850,
	"./bin.svg": 850,
	"./buttonRefreshArrows": 851,
	"./buttonRefreshArrows.svg": 851,
	"./calendar": 852,
	"./calendar.svg": 852,
	"./cameraSettingsFlip1": 853,
	"./cameraSettingsFlip1.svg": 853,
	"./chatTranslate": 854,
	"./chatTranslate.svg": 854,
	"./check": 855,
	"./check.svg": 855,
	"./check99": 856,
	"./check99.svg": 856,
	"./chevronleft": 857,
	"./chevronleft.svg": 857,
	"./chevronright": 858,
	"./chevronright.svg": 858,
	"./circlecheck": 859,
	"./circlecheck.svg": 859,
	"./clock": 860,
	"./clock.svg": 860,
	"./close": 861,
	"./close.svg": 861,
	"./closeCircle": 862,
	"./closeCircle.svg": 862,
	"./cog": 863,
	"./cog.svg": 863,
	"./cogapproved": 864,
	"./cogapproved.svg": 864,
	"./cogsquare": 865,
	"./cogsquare.svg": 865,
	"./compositionHorizontal": 866,
	"./compositionHorizontal.svg": 866,
	"./compositionVertical": 867,
	"./compositionVertical.svg": 867,
	"./confirm": 868,
	"./confirm.svg": 868,
	"./databaseSearch": 869,
	"./databaseSearch.svg": 869,
	"./delete2alternate": 870,
	"./delete2alternate.svg": 870,
	"./edit": 871,
	"./edit.svg": 871,
	"./envelope": 872,
	"./envelope.svg": 872,
	"./envelopeshop": 873,
	"./envelopeshop.svg": 873,
	"./eye": 874,
	"./eye.svg": 874,
	"./facebook": 875,
	"./facebook.svg": 875,
	"./fileFolder": 876,
	"./fileFolder.svg": 876,
	"./fileHorizontalImage": 877,
	"./fileHorizontalImage.svg": 877,
	"./filter-picture-big": 878,
	"./filter-picture-big.svg": 878,
	"./filterPicture": 879,
	"./filterPicture.svg": 879,
	"./flagEmpty": 880,
	"./flagEmpty.svg": 880,
	"./flagUnknown": 881,
	"./flagUnknown.svg": 881,
	"./folderImage": 882,
	"./folderImage.svg": 882,
	"./google": 883,
	"./google.svg": 883,
	"./gotidea": 884,
	"./gotidea.svg": 884,
	"./group-5-copy": 885,
	"./group-5-copy.svg": 885,
	"./hammer": 886,
	"./hammer.svg": 886,
	"./hammerRegular": 887,
	"./hammerRegular.svg": 887,
	"./hammerStone": 888,
	"./hammerStone.svg": 888,
	"./headidea": 889,
	"./headidea.svg": 889,
	"./heart": 890,
	"./heart.svg": 890,
	"./home": 891,
	"./home.svg": 891,
	"./home4": 892,
	"./home4.svg": 892,
	"./idea": 893,
	"./idea.svg": 893,
	"./info": 894,
	"./info.svg": 894,
	"./information-circle": 895,
	"./information-circle.svg": 895,
	"./instagram": 896,
	"./instagram.svg": 896,
	"./keyLock1": 897,
	"./keyLock1.svg": 897,
	"./like1": 898,
	"./like1.svg": 898,
	"./likecircle": 899,
	"./likecircle.svg": 899,
	"./link": 900,
	"./link.svg": 900,
	"./linkedin": 901,
	"./linkedin.svg": 901,
	"./locationTarget": 902,
	"./locationTarget.svg": 902,
	"./logo": 903,
	"./logo.svg": 903,
	"./loveIt": 904,
	"./loveIt.svg": 904,
	"./messagesBubbleSquareImage": 905,
	"./messagesBubbleSquareImage.svg": 905,
	"./minus": 906,
	"./minus.svg": 906,
	"./moodWarning": 907,
	"./moodWarning.svg": 907,
	"./moveback": 908,
	"./moveback.svg": 908,
	"./navigation-menu-2": 909,
	"./navigation-menu-2.svg": 909,
	"./navigationDown": 910,
	"./navigationDown.svg": 910,
	"./navigationDownBold": 911,
	"./navigationDownBold.svg": 911,
	"./navigationMenu": 912,
	"./navigationMenu.svg": 912,
	"./navigationMenu1": 913,
	"./navigationMenu1.svg": 913,
	"./navigationMenu3": 914,
	"./navigationMenu3.svg": 914,
	"./navigationUp": 915,
	"./navigationUp.svg": 915,
	"./navigationUpBold": 916,
	"./navigationUpBold.svg": 916,
	"./paginateFilterPicture": 917,
	"./paginateFilterPicture.svg": 917,
	"./path": 918,
	"./path.svg": 918,
	"./pencil2": 919,
	"./pencil2.svg": 919,
	"./phone": 920,
	"./phone.svg": 920,
	"./phoneRotate1": 921,
	"./phoneRotate1.svg": 921,
	"./pin": 922,
	"./pin.svg": 922,
	"./plus": 923,
	"./plus.svg": 923,
	"./points": 924,
	"./points.svg": 924,
	"./preloaderBrokenCircle": 925,
	"./preloaderBrokenCircle.svg": 925,
	"./print": 926,
	"./print.svg": 926,
	"./printLight": 927,
	"./printLight.svg": 927,
	"./printRegular": 928,
	"./printRegular.svg": 928,
	"./puzzle": 929,
	"./puzzle.svg": 929,
	"./questionHelpMessage": 930,
	"./questionHelpMessage.svg": 930,
	"./questionMarkCircle": 931,
	"./questionMarkCircle.svg": 931,
	"./questionUser": 932,
	"./questionUser.svg": 932,
	"./rectangle": 933,
	"./rectangle.svg": 933,
	"./refresh": 934,
	"./refresh.svg": 934,
	"./resize-expand-arrow": 935,
	"./resize-expand-arrow.svg": 935,
	"./results": 936,
	"./results.svg": 936,
	"./rotate": 937,
	"./rotate.svg": 937,
	"./roundAbout": 938,
	"./roundAbout.svg": 938,
	"./schoolTeacherCorrect": 939,
	"./schoolTeacherCorrect.svg": 939,
	"./search": 940,
	"./search.svg": 940,
	"./settings": 941,
	"./settings.svg": 941,
	"./shape": 942,
	"./shape.svg": 942,
	"./share": 943,
	"./share.svg": 943,
	"./signalfull": 944,
	"./signalfull.svg": 944,
	"./signallow": 945,
	"./signallow.svg": 945,
	"./signalmedium": 946,
	"./signalmedium.svg": 946,
	"./signalstrong": 947,
	"./signalstrong.svg": 947,
	"./signalverylow": 948,
	"./signalverylow.svg": 948,
	"./skull": 949,
	"./skull.svg": 949,
	"./skull1": 950,
	"./skull1.svg": 950,
	"./smile": 951,
	"./smile.svg": 951,
	"./speakers": 952,
	"./speakers.svg": 952,
	"./star": 953,
	"./star.svg": 953,
	"./subtract-circle-alternate": 954,
	"./subtract-circle-alternate.svg": 954,
	"./taskchecklistadd": 955,
	"./taskchecklistadd.svg": 955,
	"./twitter": 956,
	"./twitter.svg": 956,
	"./unlink": 957,
	"./unlink.svg": 957,
	"./unlinkBold": 958,
	"./unlinkBold.svg": 958,
	"./unlock": 959,
	"./unlock.svg": 959,
	"./upDouble": 960,
	"./upDouble.svg": 960,
	"./upload": 961,
	"./upload.svg": 961,
	"./user": 962,
	"./user.svg": 962,
	"./viewOff": 963,
	"./viewOff.svg": 963,
	"./viewOn": 964,
	"./viewOn.svg": 964,
	"./volumeControl": 965,
	"./volumeControl.svg": 965,
	"./volumeControl2": 966,
	"./volumeControl2.svg": 966,
	"./warningTriangle": 967,
	"./warningTriangle.svg": 967,
	"./youtube": 968,
	"./youtube.svg": 968,
	"./zamek": 969,
	"./zamek.svg": 969,
	"./zoomIn": 970,
	"./zoomIn.svg": 970,
	"./zoomOut": 971,
	"./zoomOut.svg": 971
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 972;
module.exports = webpackAsyncContext;